<template>
    <div class="option-box">
        <div class="group-box">
            <div class="group-title">开启积分</div>
            <div class="group-data">
                <el-radio v-model="formData.receive_state" label="1">是</el-radio>&nbsp;&nbsp;
                <el-radio v-model="formData.receive_state" label="0">否</el-radio>
            </div>
        </div>
        <div class="group-box">
            <div class="group-title">设置积分有效期</div>
            <div class="group-data">
                积分有效期：
                <el-select v-model="formData.valid_month" placeholder="请选择">
                    <el-option
                            v-for="(item, k) in expireSelectList"
                            :key="k"
                            :label="item.label"
                            :value="item.value">
                    </el-option>
                </el-select>
                <el-tooltip placement="right">
                    <div slot="content">
                        设置为3个月，表示今年获得的积分将在明年03月31日 23:59:59失效，<br/>
                        即当年获得的积分往后加3个月才失效。。<br/><br/>
                        设置为1年，表示今年获得的积分将在明年12月31日 23:59:59失效，<br/>
                        即当年获得的积分往后加1年才失效
                    </div>
                    <i class="el-icon-info expire-tips"></i>
                </el-tooltip>
            </div>
        </div>
        <div class="group-box">
            <div class="group-title">设置积分规则</div>
            <div class="group-data">
                <el-row class="group-line title">
                    <el-col :span="6">
                        积分条件
                    </el-col>
                    <el-col :span="6">
                        支付方式
                    </el-col>
                    <el-col :span="6">
                        获得积分
                    </el-col>
                    <el-col :span="6">
                        每日积分上限
                    </el-col>
                </el-row>
                <el-row class="group-line">
                    <el-col :span="6">
                        消费项目
                    </el-col>
                    <el-col :span="6">
                        <p>余额支付</p>
                        <p>其他支付</p>
                    </el-col>
                    <el-col :span="6">
                        <p><el-input class="score-input" size="small" v-model="formData.rule_list.product.balance_pay" placeholder="" /> 积分/元</p>
                        <p><el-input class="score-input" size="small" v-model="formData.rule_list.product.other_pay" placeholder="" /> 积分/元</p>
                    </el-col>
                    <el-col :span="6">
                        <p><score-day-max-input v-model="formData.rule_list.product.balance_day_max" /></p>
                        <p><score-day-max-input v-model="formData.rule_list.product.other_day_max" /></p>
                    </el-col>
                </el-row>
                <el-row class="group-line">
                    <el-col :span="6">
                        购买卡项
                    </el-col>
                    <el-col :span="6">
                        <p>余额支付</p>
                        <p>其他支付</p>
                    </el-col>
                    <el-col :span="6">
                        <p><el-input class="score-input" size="small" v-model="formData.rule_list.card.balance_pay" placeholder="" /> 积分/元</p>
                        <p><el-input class="score-input" size="small" v-model="formData.rule_list.card.other_pay" placeholder="" /> 积分/元</p>
                    </el-col>
                    <el-col :span="6">
                        <p><score-day-max-input v-model="formData.rule_list.card.balance_day_max" /></p>
                        <p><score-day-max-input v-model="formData.rule_list.card.other_day_max" /></p>
                    </el-col>
                </el-row>
                <el-row class="group-line">
                    <el-col :span="6">
                        购买产品
                    </el-col>
                    <el-col :span="6">
                        <p>余额支付</p>
                        <p>其他支付</p>
                    </el-col>
                    <el-col :span="6">
                        <p><el-input class="score-input" size="small" v-model="formData.rule_list.goods.balance_pay" placeholder="" /> 积分/元</p>
                        <p><el-input class="score-input" size="small" v-model="formData.rule_list.goods.other_pay" placeholder="" /> 积分/元</p>
                    </el-col>
                    <el-col :span="6">
                        <p><score-day-max-input v-model="formData.rule_list.goods.balance_day_max" /></p>
                        <p><score-day-max-input v-model="formData.rule_list.goods.other_day_max" /></p>
                    </el-col>
                </el-row>
                <el-row class="group-line">
                    <el-col :span="6">
                        充值
                    </el-col>
                    <el-col :span="6">
                        &nbsp;
                    </el-col>
                    <el-col :span="6">
                        <p><el-input class="score-input" size="small" v-model="formData.rule_list.recharge.other_pay" placeholder="" /> 积分/元</p>
                    </el-col>
                    <el-col :span="6">
                        <p><score-day-max-input v-model="formData.rule_list.recharge.other_day_max" /></p>
                    </el-col>
                </el-row>
                <el-row class="group-line">
                    <el-col :span="6">
                        办理会员
                    </el-col>
                    <el-col :span="6">
                        &nbsp;
                    </el-col>
                    <el-col :span="6">
                        <p><el-input class="score-input" size="small" v-model="formData.rule_list.join_user.other_pay" placeholder="" /> 积分/元</p>
                    </el-col>
                    <el-col :span="6">
                        <p><score-day-max-input v-model="formData.rule_list.join_user.other_day_max" /></p>
                    </el-col>
                </el-row>
                <el-row class="group-line">
                    <el-col :span="6">
                        会员续费
                    </el-col>
                    <el-col :span="6">
                        &nbsp;
                    </el-col>
                    <el-col :span="6">
                        <p><el-input class="score-input" size="small" v-model="formData.rule_list.extend_user.other_pay" placeholder="" /> 积分/元</p>
                    </el-col>
                    <el-col :span="6">
                        <p><score-day-max-input v-model="formData.rule_list.extend_user.other_day_max" /></p>
                    </el-col>
                </el-row>
                <div class="blank10"></div>
                <div class="blank10"></div>
                <div class="blank10"></div>
                <div class="blank10"></div>
                <div class="blank10"></div>
                <el-row class="tc">
                    <el-col :span="24">
                        <el-button type="primary" @click="onSubmit">保存</el-button>
                    </el-col>
                </el-row>
            </div>
        </div>
    </div>
</template>

<script>
    import obj from "@/js/obj";
    import ScoreDayMaxInput from "@/model/Score/ScoreDayMaxInput";
    export default {
        name: "ScoreBaseOption",
        components: {ScoreDayMaxInput},
        data: () => ({
            formData: {
                receive_state: "0",
                cycle_month: "",
                valid_month: "12000",
                rule_list: {
                    product: {
                        balance_pay: "",
                        balance_day_max: 0,
                        other_pay: "",
                        other_day_max: 0,
                    },
                    card: {
                        balance_pay: "",
                        balance_day_max: 0,
                        other_pay: "",
                        other_day_max: 0,
                    },
                    goods: {
                        balance_pay: "",
                        balance_day_max: 0,
                        other_pay: "",
                        other_day_max: 0,
                    },
                    recharge: {
                        other_pay: "",
                        other_day_max: 0,
                    },
                    join_user: {
                        other_pay: "",
                        other_day_max: 0,
                    },
                    extend_user: {
                        other_pay: "",
                        other_day_max: 0,
                    }
                }
            },
            expireSelectList: [
                {
                    label: "永久有效",
                    value: "12000"
                }, {
                    label: "3个月",
                    value: "3"
                }, {
                    label: "6个月",
                    value: "6"
                }, {
                    label: "9个月",
                    value: "9"
                }, {
                    label: "1年",
                    value: "12"
                }, {
                    label: "2年",
                    value: "24"
                }, {
                    label: "3年",
                    value: "36"
                }, {
                    label: "4年",
                    value: "48"
                }, {
                    label: "5年",
                    value: "60"
                }
            ]
        }),
        mounted: function () {
            this.getOption();
        },
        methods: {
            /**
             * 获取配置
             */
            getOption: function () {
                obj.postData("score/get_receive_option", {}, res => {
                    if(res.errcode === 0) {
                        if (!obj.isEmpty(res.data.option)) {
                            this.formData = res.data.option;
                        }
                    }
                });
            },

            /**
             * 提交
             */
            onSubmit: function () {
                if(obj.isEmpty(this.formData.valid_month) || !this.formData.valid_month.match(/^[0-9]+$/)) {
                    obj.message.error("请选择积分有效期");
                    return;
                }

                let dataStr = JSON.stringify(this.formData);
                obj.postData("score/set_receive_option", {option: dataStr}, res => {
                    if(res.errcode === 0)
                        obj.message.success("设置成功");
                    else
                        obj.message.error(res.errdesc);
                });
            }
        }
    }
</script>

<style scoped>
    .group-box{
        margin-top: 20px;
        margin-bottom: 50px;
    }
    .group-title::before{
        content: " ";
        display: inline-block;
        vertical-align: text-top;
        width: 4px;
        height: 15px;
        background-color: #0f9cf3;
        border-radius: 2px;
        margin-right: 6px;
    }
    .group-title{
        font-weight: bold;
        font-size: 14px;
        line-height: 20px;
    }
    .group-data{
        margin-top: 16px;
    }
    .expire-tips{
        margin-left: 10px;
        color: #cccccc;
    }

    .group-line{
        border-bottom: 1px solid #ebedf0;
        line-height: 40px;
        padding: 5px 0px;
    }
    .group-line.title{
        color: #909399;
    }
    .score-input{
        width: 80px;
    }
</style>
